import { WorkplacePatientStatus } from '../../Modules/EArchive/Enums/WorkplacePatientStatus.enum';
import { PatientProfileDataQuery } from '../../graphql/graphql';

export const canConnectWithPatient = (
	patientProfile?: PatientProfileDataQuery,
) => {
	let enabled = true;
	let reason = undefined;

	if (
		!(
			patientProfile?.user?.hasMeddi &&
			patientProfile?.user?.workplaceMember?.status !==
				WorkplacePatientStatus.PENDING
		)
	) {
		enabled = false;
		reason = 'component.treatmentModal.patientDidNotRegistered';
	}

	if (
		patientProfile?.user?.workplaceMember?.status ===
			WorkplacePatientStatus.ARCHIVED_BY_WORKPLACE ||
		patientProfile?.user?.workplaceMember?.status ===
			WorkplacePatientStatus.ARCHIVED_BY_PATIENT
	) {
		enabled = false;
		reason = 'component.treatmentModal.patientIsArchived';
	}

	return { enabled, reason };
};
